import React from 'react';
import { Route } from 'react-router-dom';
import { Redirect } from 'react-router';
import { useSelector } from 'react-redux';
import {
  hasViewUserListing,
  hasViewUserPerformanceReport,
} from 'selectors/permissions';
import lazyLoad from 'utils/lazyLoad';
import { getRouterPath } from 'utils/navigation';
import useFeatureToggle from 'hooks/useFeatureToggle';

const UserListPage = lazyLoad(
  () => import(/* webpackChunkName: "UserListPage" */ 'pages/UserListPage'),
);
const PerformanceReportContainer = lazyLoad(
  () =>
    import(
      /* webpackChunkName: "PerformanceReportContainer" */ 'pages/Reports/PerformanceReports/PerformanceReportContainer'
    ),
);
const UnauthorizedPageAccess = lazyLoad(
  () =>
    import(
      /* webpackChunkName: "UnauthorizedPageAccess" */ 'pages/UnauthorizedPageAccess'
    ),
);

const UserListRedirect = () => <Redirect to={getRouterPath('/users')} />;

export default function useUsersRoutes() {
  const canViewUserListing = useSelector(hasViewUserListing);
  const canViewUserPerformanceReport = useSelector(
    hasViewUserPerformanceReport,
  );
  const isGroupUserIncidentPerformanceEnabled = useFeatureToggle(
    'GROUP_USER_INCIDENT_PERFORMANCE',
  );
  const isIncidentManagementEnabled = useFeatureToggle(
    'INCIDENT_MANAGEMENT_MVP',
  );
  return [
    canViewUserListing && (
      <Route
        exact
        path={[getRouterPath('/users'), getRouterPath('/users([:/]?)none')]}
        component={UserListPage}
      />
    ),
    canViewUserListing && (
      <Route
        exact
        path={[getRouterPath('/UsersPlace:none'), getRouterPath('/UsersPlace')]}
        component={UserListRedirect}
      />
    ),
    <Route
      path={[
        getRouterPath('/UserPerformance/alerts'),
        getRouterPath('/UserPerformance*'),
      ]}
      component={props =>
        canViewUserPerformanceReport ? (
          <PerformanceReportContainer
            recipientType="User"
            isGroupUserIncidentPerformanceEnabled={
              isGroupUserIncidentPerformanceEnabled
            }
            isIncidentManagementEnabled={isIncidentManagementEnabled}
            {...props}
          />
        ) : (
          <UnauthorizedPageAccess />
        )
      }
    />,
  ];
}
